import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/car';

export default {
    findById(carId) {
        return http.get({
            url: baseUrl + `/${carId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCar')
        });
    },
    findByCodigos(cars) {
        return http.get({
            url: baseUrl + `/codigos/?cars=${cars.join(',')}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCar')
        });
    },

    buscarCarPorCpfCnpjVinculado(cpfCnpj) {
        return http.get({
            url: baseUrl + `/${cpfCnpj}/vinculado`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCarsVinculados')
        });
    },

    buscarGeometria(codigo) {
        return http.get({
            url: baseUrl + `/geometria/${codigo}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCar')
        });
    }
};
